import get from "lodash/get"

export const selectData = state => get(state, "data")
export const selectIdentifiers = state => get(state, "identifiers")
export const selectIsLoading = state => get(state, "isLoading")
export const selectHasFetched = state => get(state, "hasFetched")
export const selectLoadingError = state => get(state, "loadingError")
export const selectSelectedHash = state => get(state, "selectedHash")
